import { render, staticRenderFns } from "./Funding.vue?vue&type=template&id=839f8d50&"
import script from "./Funding.vue?vue&type=script&lang=js&"
export * from "./Funding.vue?vue&type=script&lang=js&"
import style0 from "./Funding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports